import { useTranslation } from 'react-i18next';

import { GroupedBenefits } from './GroupedBenefits';
import { CategoryResponseDto } from 'enrollment/queries/useBenefitCategoryQuery/types';
import { PSBannerWrapper } from 'enrollment/components/Shared/Banner';
import { GenericGroupingContainer } from 'enrollment/features/Shared/PreviewContainers/GenericGroupingContainer';

export interface CategoriesProps {
  benefitCategories: string[];
  benefitCategoryData: CategoryResponseDto;
  currentBenefitCategory: string;
  benefitCategoryNames: string[];
  isLoading: boolean;
}

export function determineColor(benefitCategory: string) {
  switch (benefitCategory) {
    case 'category_1':
      return 'annotation5';
    case 'category_2':
      return 'annotation2';
    case 'category_3':
      return 'annotation3';
    default:
      return 'annotation4';
  }
}

export const Categories = ({
  benefitCategories,
  benefitCategoryData,
  currentBenefitCategory,
  benefitCategoryNames,
  isLoading,
}: CategoriesProps) => {
  const { t } = useTranslation('messages.notEligible');

  return (
    <div>
      {benefitCategories.map((benefitCategory, index) => {
        const benefitGroupName = benefitCategoryNames[index];
        const color = determineColor(benefitCategory);
        const benefitPreviews = GroupedBenefits({
          benefitCategoryData,
          benefitCategory,
          currentBenefitCategory,
          color,
          loading: isLoading,
        });

        const sortedBenefitPreviews = benefitPreviews.sort((a, b) => {
          const orderA = a?.props.benefitData.benefit.display_order || 0;
          const orderB = b?.props.benefitData.benefit.display_order || 0;

          return orderA - orderB;
        });

        const hasEligibleBenefit = sortedBenefitPreviews.find(
          (benefit) => benefit
        );

        return (
          <GenericGroupingContainer
            key={index}
            id={benefitGroupName}
            groupName={benefitGroupName}
            dataTestId="benefit-grouping-container"
            loading={isLoading && !hasEligibleBenefit}
            className="category-container"
          >
            {hasEligibleBenefit ? (
              <div className="tile-grid m-0">{benefitPreviews}</div>
            ) : (
              <div className="row m-0">
                <div className="col p-0">
                  <PSBannerWrapper
                    message={t('notEligible')}
                    level="info"
                    icon={true}
                    extraClass="mb-4"
                  />
                </div>
              </div>
            )}
          </GenericGroupingContainer>
        );
      })}

      {/* commenting this code for now as it’s been decided 
      that we’re going to hold off on implementing batch decline 
      so that we can first implement the active workflow */}

      {/* till then please don't remove this DeclinePassiveBenefitsModal component */}
      {/* <DeclinePassiveBenefitsModal benefitCategoryData={benefitCategoryData} /> */}
    </div>
  );
};
